import createContext from '../../../support/helpers/createContext';

import { State, SimpleViewAction } from './SimpleView';
import { Market } from '../../../types/shared/Market';
import { VendorList } from '../../../types/shared/Vendor';
import { PlacementByVendor } from '../../../types/shared/Placement';
import { Tag } from '../../../types/shared/Tag';

type Dispatch = (action: SimpleViewAction) => void;

let [
  useSimpleViewDispatch,
  SimpleViewDispatchProvider,
] = createContext<Dispatch>();

type SimpleViewState = {
  market: Market;
  placement: PlacementByVendor;
  tags: Array<Tag>;
  vendors: VendorList;
} & State;

let [
  useSimpleViewState,
  SimpleViewStateProvider,
] = createContext<SimpleViewState>();

export {
  useSimpleViewDispatch,
  SimpleViewDispatchProvider,
  useSimpleViewState,
  SimpleViewStateProvider,
};
